import axios from 'axios'
import store from '../redux/store'
import { LOGOUT } from '../redux/actions/types'
import { setAlert } from '../redux/actions/alert'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})
/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.data?.code === 'BETA_ACCOUNT_READ_ONLY') {
      const message = err.response.data.errors?.[0]?.msg || 'Make changes in the new Fit Kit Studio.'
      store.dispatch(setAlert(message, 'danger', 15000))
      // Existing action handlers also display errors; show this guidance once,
      // including for actions that otherwise do not display their failures.
      err.response.data.errors = []
    }
    if (err.response?.status === 401) {
      store.dispatch({ type: LOGOUT })
    }
    return Promise.reject(err)
  }
)

export default api
